<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>PROGRAMAR INDUCCIÓN</h2></mat-dialog-content
>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>


<mat-dialog-content class="modal-body">
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Fecha:</label>
        <div class="col-md-9">
            <mat-form-field appearance="outline">
                <mat-label>Fecha de Inducción</mat-label>
              <input
                matInput
                [matDatepicker]="pckrFechaInduccion"
                [(ngModel)]="model.fechaInduccion"
                [value]="model.fechaInduccion"
                name="fechaInduccion"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pckrFechaInduccion"
              ></mat-datepicker-toggle>
              <mat-datepicker #pckrFechaInduccion></mat-datepicker>    
            </mat-form-field>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-3 control-label">Hora:</label>
        <div class="col-md-9">
          <mat-form-field appearance="outline">
            <mat-label>hora</mat-label>
            <input matInput type="time" name="horaInduccion" [(ngModel)]="model.horaInduccion" required />
            
            <!-- [(ngModel)]="model.notificarA"  -->
          </mat-form-field>                
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-3 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Ingresa los comentarios</mat-label>
            <textarea matInput placeholder="Comentarios" [(ngModel)]="model.comentarios" rows="5" name="comentarios" [maxlength]="2000"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" [mat-dialog-close]="model" mat-button cdkFocusInitial>Guardar</button>
  <button type="button" class="btn btn-celeste" mat-button (click)="onNoClick()">Cancelar</button>
</mat-dialog-actions>

</form>

<!-- <pre>{{ fechaInduccion | json }}</pre>
<pre>{{ model.fechaHoraInduccion | date: "HH:mm" }}</pre> -->
<!-- <pre>{{ model | json }}</pre> -->

